module.exports = __webpack_public_path__ + "static/img/CERTIFICATION.e81244d8.jpg";